import { DateTime } from "luxon";

const statuses: Record<string, "success" | "secondary" | "error"> = {
    completed: "success",
    booked: "success",
    confirmed: "success",
    success: "success",
    rescheduled: "secondary",
    cancelled: "error",
};

export const getChipColor = (appointmentStatus: string) => statuses[appointmentStatus.toLowerCase()];

export const getDateTimeLabel = (isoString: string) => {
    const date = DateTime.fromISO(isoString).toFormat("ccc, dd LLLL yyyy");
    const time = DateTime.fromISO(isoString).toFormat("hh:mm a");

    return { date, time };
};
